import { Component } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { SubHeaderData } from 'src/app/models/sub-header-data';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss'],
    standalone: false
})
export class ReportsComponent {
    subHeaderData: SubHeaderData;

    constructor(
            private translocoService: TranslocoService) {
        this.subHeaderData = this.setSubHeaderValues();
    }

    setSubHeaderValues(): SubHeaderData {
        let headerData = new SubHeaderData();
        headerData.displayText = this.translocoService.translate('HOME_PAGE.HEADER.IDMS_DROPDOWN.LINK.REPORTS');
        headerData.disableActions = false;
        headerData.defaultImageSrc = '../../../../../../../assets/media/logos/report-black.png';
        headerData.mouseOverImageSrc = '../../../../../../../assets/media/logos/report-yellow.png';

        return headerData;
    }
}
